// utils/dayjs.ts
// One-time date setup, imported once in App.tsx. dayjs plugins and locale are global,
// so every `import dayjs from 'dayjs'` in the app gets French formats after this runs.
// (Replaces moment.js: ~60 KB smaller, and moment's French locale was only ever loaded
// into a second copy of moment, so most moment dates actually showed in English.)
import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import localizedFormat from 'dayjs/plugin/localizedFormat'; // format('LLL')
import relativeTime from 'dayjs/plugin/relativeTime'; // fromNow()

dayjs.extend(localizedFormat);
dayjs.extend(relativeTime);
dayjs.locale('fr');

export default dayjs;
